import _slicedToArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import React from "react";
import { useSpring } from "react-spring";
import { useHover, useWindowSize } from "../../../shared/hooks";
import Pricing from "../../Pricing";
import CartControl from "./CartControl";
import AddToCartButton from "./AddToCartButton";
import * as S from "./styles";
export var Product = function Product(e) {
  var t = e.image,
      r = e.imageAlt,
      o = e.productName,
      a = e.productUrl,
      c = e.reviewData,
      _e$showReviewCount = e.showReviewCount,
      i = _e$showReviewCount === void 0 ? !1 : _e$showReviewCount,
      n = e.price,
      d = e.promoPrice,
      m = e.promoText,
      l = e.description,
      s = e.addedToCart,
      u = e.removedFromCart,
      p = e.onAddToCartClick,
      C = e.onRemoveFromCartClick,
      g = e.isOnSale,
      _e$isOutOfStock = e.isOutOfStock,
      R = _e$isOutOfStock === void 0 ? !1 : _e$isOutOfStock,
      _e$showAddToCart = e.showAddToCart,
      f = _e$showAddToCart === void 0 ? !0 : _e$showAddToCart,
      v = e.tabIndex,
      _e$showAddToCartButto = e.showAddToCartButton,
      w = _e$showAddToCartButto === void 0 ? !1 : _e$showAddToCartButto,
      k = e.imageBackgroundColor,
      O = e.pricingOverride,
      T = __rest(e, ["image", "imageAlt", "productName", "productUrl", "reviewData", "showReviewCount", "price", "promoPrice", "promoText", "description", "addedToCart", "removedFromCart", "onAddToCartClick", "onRemoveFromCartClick", "isOnSale", "isOutOfStock", "showAddToCart", "tabIndex", "showAddToCartButton", "imageBackgroundColor", "pricingOverride"]);

  var _useHover = useHover(),
      _useHover2 = _slicedToArray(_useHover, 2),
      A = _useHover2[0],
      E = _useHover2[1],
      _useWindowSize = useWindowSize(),
      P = _useWindowSize.isMobile,
      b = "object" == typeof t,
      h = useSpring({
    transform: E ? "scale(1.125)" : "scale(1)"
  });

  return React.createElement(S.Product, Object.assign({
    "aria-label": o,
    "aria-describedby": c ? "".concat(c.rating, " stars out of ").concat(c.numOfReviews, " reviews") : null,
    href: a,
    ref: A,
    "data-testid": "productCard",
    tabIndex: v
  }, T), React.createElement(S.ImageWrapper, null, b ? React.createElement(S.AnimatedProductImageComponent, {
    alt: r,
    style: h,
    imageBackgroundColor: k
  }, t) : React.createElement(S.AnimatedProductImage, {
    alt: r,
    src: t,
    style: h,
    imageBackgroundColor: k
  }), !!f && !R && React.createElement(S.CartControlWrapper, null, React.createElement(CartControl, {
    showIcon: E || P,
    addedToCart: s,
    removedFromCart: u,
    onAddClick: p,
    onRemoveClick: C,
    tabIndex: v
  })), g && React.createElement(S.SaleIcon, null, "Sale"), R && React.createElement(S.OutOfStock, {
    "data-testid": "out-of-stock"
  }, "Out of Stock")), React.createElement(S.ContentWrapper, null, o && React.createElement(S.ProductName, null, o), O || (n ? React.createElement(Pricing, {
    price: n,
    promoText: m,
    promoPrice: d
  }) : null), c && React.createElement(S.Reviews, {
    numOfReviews: c.numOfReviews,
    rating: c.rating,
    showNumOfReviews: i
  }), l && React.createElement(S.Description, {
    "data-testid": "product-description"
  }, l)), !!w && !R && React.createElement(AddToCartButton, {
    addedToCart: s,
    onAddClick: p
  }));
};
export default React.memo(Product);